import { Link } from "react-router-dom";
import { useEffect } from "react";
import { deleteZombie } from '../../utils/api';

// COMPONENTS //
import LayeredPixiImage from "../../components/LayeredPixiImage";
import WakeButton from "../../components/WakeButton";
import BrushButton from "../../components/BrushButton";
import Borders from "../../components/Borders";

// SOUNDS //
import useSound from "../../hooks/useSound";
import evilLaugh from "../../assets/sfx/laughter_evil_01.mp3";
import churchBell01 from "../../assets/sfx/church_bell_01.mp3";

// STYLES //
import "./styles.css";

// IMAGES //
import borderPage from "../../assets/border_page.png";
import brushStroke from "../../assets/brush_stroke_01.png";
import drawing from "../../assets/outcome_drawing.png";
import background from "../../assets/outcome_bg.png";
import clothing from "../../assets/outcome_clothing.png";
import complexion from "../../assets/outcome_complexion.png";
import eyes from "../../assets/outcome_eye.png";
import hair from "../../assets/outcome_hair.png";

const outcomeLayers = {
    background: background,
    clothing: clothing,
    complexion: complexion,
    eyes: eyes,
    hair: hair,
    drawing: drawing
};

export default function Outcome({ zombie, setZombie, stopMusic }) {

    const { playRandom, stopSound } = useSound();

    useEffect(() => {
        playRandom(
            [
                evilLaugh,
                churchBell01
            ],
            1
        );

        return stopSound;
    }, []);

    return (
        <div className="game-page outcome-page">
            <Borders image={borderPage} scale={0.98} />

            <h1 className="game-title">L'ULTIMO DOLORE</h1>

            <div className="game-main-grid">

                <div className="game-image-wrapper">
                    {/* <img
                        className="game-image outcome-image"
                        src={ undeadDead }
                        alt="Parent Holding Zombie Kid in Arms"
                    /> */}
                    <LayeredPixiImage
                        layers={outcomeLayers}
                        zombie={zombie}
                        layerOptions={{
                            complexion: { alpha: 0.60 }
                        }}
                    />
                </div>

                <section className="game-copy game-copy-centered">
                    <p>The deed is done, though you may never quite recover. Still, life goes on. And who knows? Perhaps another child will bring joy back into your home. Assuming, of course, the zombies don't get to them first.</p>

                    {/* <div className="page-actions"> */}
                    <div className="outcome-actions">
                        <BrushButton
                            className="outcome-button"
                            brushImage={brushStroke}
                            brushMode="contain"
                            onClick={async () => {
                                stopSound?.();

                                if (zombie?._id){
                                    deleteZombie(zombie._id);
                                    localStorage.removeItem("currentZombieId");
                                    setZombie({});
                                }
                            }}
                            to="/createzombie"
                        >
                            <span>Have</span>
                            <span>Another</span>
                            <span>Baby</span>
                        </BrushButton>

                        <WakeButton
                            zombie={zombie}
                            setZombie={setZombie}
                            stopMusic={stopMusic}
                            stopSound={stopSound}
                            brushImage={brushStroke}
                            brushMode="contain"
                        >
                            <span>Wake Up</span>
                            <span>from this</span>
                            <span>Nightmare</span>
                        </WakeButton>
                    </div>
                </section>

            </div>
        </div>
    );
}
